import React from 'react';

const SvgLanguagesBubble = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 242 131" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#languages-bubble_svg__a)" clipRule="evenodd">
      <path
        fillRule="evenodd"
        d="M25.58 122.4c6.58 6.84 22.43 7.96 30.7 2.52 5.74-3.8 8.13-9.77 6.85-15.35l3.82-8.05-7.83.97c-6.62-6.67-22.33-7.73-30.5-2.33-8.27 5.45-9.63 15.4-3.04 22.24z"
        fill="#fff"
      />
      <path
        d="M25.58 122.4c6.58 6.84 22.43 7.96 30.7 2.52 5.74-3.8 8.13-9.77 6.85-15.35l3.82-8.05-7.83.97c-6.62-6.67-22.33-7.73-30.5-2.33-8.27 5.45-9.63 15.4-3.04 22.24z"
        stroke="#3F2D51"
      />
    </g>
    <path
      d="M43.45 112.74a4.63 4.63 0 01-1.28 3.23 4.35 4.35 0 01-3.23 1.25 4.38 4.38 0 01-3.22-1.25c-.4-.4-.7-.87-.93-1.42a4.77 4.77 0 01-.34-1.81c0-.66.11-1.27.34-1.81a4.23 4.23 0 012.35-2.32 4.9 4.9 0 011.8-.32c.65 0 1.25.1 1.8.32a4.2 4.2 0 012.71 4.13zm-1.28 0a3.72 3.72 0 00-.88-2.4 3.1 3.1 0 00-2.35-1 3.15 3.15 0 00-2.34 1 3.72 3.72 0 00-.86 2.4c0 .47.07.92.22 1.33a3.05 3.05 0 002.98 2.08c.49 0 .93-.09 1.33-.27a3.02 3.02 0 001.67-1.8c.15-.42.23-.87.23-1.34zm3.98 4.26h-1.13v-5.69h1.13V117zm.19-7.74a.7.7 0 01-.23.52.74.74 0 01-.53.2.74.74 0 01-.52-.2.7.7 0 01-.22-.52c0-.2.07-.38.22-.52a.72.72 0 01.52-.21c.21 0 .39.07.53.21.15.14.23.31.23.52zm3.4 5.26h-1.2v-6.02h1.2v6.02zm.2 1.76c0 .2-.07.4-.22.55a.76.76 0 01-.58.24.78.78 0 01-.58-1.33.76.76 0 01.58-.24.78.78 0 01.8.78z"
      fill="#3F2D51"
    />
    <g filter="url(#languages-bubble_svg__b)" clipRule="evenodd">
      <path
        fillRule="evenodd"
        d="M181.9 43.08c-2.48-2.8-3.9-6.07-3.9-9.58 0-12.92 12.09-18.5 27-18.5s27 6.26 27 18.5S219.91 52 205 52a35.56 35.56 0 01-16.36-3.78l-8.73 2.37 1.99-7.5z"
        fill="#fff"
      />
      <path
        d="M181.9 43.08c-2.48-2.8-3.9-6.07-3.9-9.58 0-12.92 12.09-18.5 27-18.5s27 6.26 27 18.5S219.91 52 205 52a35.56 35.56 0 01-16.36-3.78l-8.73 2.37 1.99-7.5z"
        stroke="#3F2D51"
      />
    </g>
    <path
      d="M191 31.63v7.77h1v-9.32a17.4 17.4 0 001.39-3.14l-.94-.45a15.92 15.92 0 01-3.3 5.9l.32 1.06c.54-.57 1.05-1.18 1.52-1.82zm9 .5l-.89.3a40.04 40.04 0 011.88 5.43l.88-.4a41.77 41.77 0 00-1.86-5.33zm-4.8-2.88h5.3a9.56 9.56 0 01-.8 1.96l.97.28c.35-.84.63-1.7.85-2.56v-.66h-5.96c.16-.49.33-1 .47-1.55l-.95-.2a15.96 15.96 0 01-2.3 5.17l.86.53c.59-.9 1.1-1.88 1.55-2.97zm1.74 10.05c.77 0 1.16-.39 1.16-1.17v-7.7h-.97v7.44c0 .37-.19.55-.54.55a26 26 0 01-1.7-.07l.22.95h1.83zm-2.1-7.05a22.31 22.31 0 01-2 5.04l.94.33a21.96 21.96 0 001.97-5.12l-.9-.25zm10.81-5.84c-.15.96-.32 1.9-.52 2.83h-1.7v.96h1.5a38.72 38.72 0 01-1.16 4c.79.57 1.52 1.11 2.16 1.63a9.38 9.38 0 01-2.58 2.79l.7.84a10.67 10.67 0 002.66-2.99c.7.6 1.3 1.12 1.78 1.63l.69-.8c-.52-.5-1.18-1.08-1.99-1.7a15.34 15.34 0 001.37-5.79v-.57h-2.42c.17-.84.34-1.77.5-2.75l-.99-.08zm.73 8.57l-1.5-1.08c.37-.98.72-2.21 1.05-3.7h1.64c-.13 1.8-.52 3.39-1.2 4.78zm2.66-2.54v.98h3.16v4.17c0 .48-.16.72-.49.72l-1.87-.02.26.96h2.02c.73 0 1.1-.45 1.1-1.35v-4.48h2.86v-.98h-2.86V31c.84-.84 1.62-1.75 2.29-2.72v-.98h-6.06v.98h4.9c-.68.95-1.4 1.75-2.15 2.4v1.77h-3.16zm9.3-4.44l.23 7.31h.87l.21-7.3h-1.3zm.65 8.33a.75.75 0 00-.59.24.76.76 0 00-.25.59c0 .24.09.43.25.6a.8.8 0 00.6.24.9.9 0 00.6-.24.81.81 0 00.25-.6.81.81 0 00-.85-.83z"
      fill="#3F2D51"
    />
    <g filter="url(#languages-bubble_svg__c)" clipRule="evenodd">
      <path
        fillRule="evenodd"
        d="M130.15 25.45c2.18-2.39 3.44-3.69 3.44-8.2 0-11.46-14.95-15.82-28.09-15.82S76 6.6 76 17.26s16.36 15.83 29.5 15.83c5.42 0 14.7-1.21 18.7-3.24l7.7 2.03-1.75-6.43z"
        fill="#fff"
      />
      <path
        d="M130.15 25.45c2.18-2.39 3.44-3.69 3.44-8.2 0-11.46-14.95-15.82-28.09-15.82S76 6.6 76 17.26s16.36 15.83 29.5 15.83c5.42 0 14.7-1.21 18.7-3.24l7.7 2.03-1.75-6.43z"
        stroke="#3F2D51"
      />
    </g>
    <path
      d="M86.22 20.1v.9h-1.09v-9.07h1.13v4.23h.03c.2-.28.46-.51.8-.7a2.82 2.82 0 012.38-.07 2.8 2.8 0 011.49 1.6 3.37 3.37 0 010 2.34 2.73 2.73 0 01-2.66 1.84c-.4-.01-.8-.1-1.17-.28a2.23 2.23 0 01-.88-.79h-.03zM90 18.14c0-.26-.04-.52-.12-.76-.08-.25-.2-.47-.36-.66a1.7 1.7 0 00-.6-.46c-.23-.11-.5-.17-.81-.17a1.79 1.79 0 00-1.4.63c-.16.19-.3.4-.4.66a2.32 2.32 0 000 1.56c.1.24.24.46.4.66a1.85 1.85 0 001.4.61c.3 0 .58-.06.81-.17a1.84 1.84 0 00.96-1.13c.08-.25.12-.5.12-.77zm8.17 0a3 3 0 01-.9 2.18 2.98 2.98 0 01-2.18.84 2.98 2.98 0 01-2.18-.84c-.27-.28-.49-.6-.65-.96a3.14 3.14 0 01-.23-1.22 2.94 2.94 0 01.88-2.15 3.2 3.2 0 012.18-.84 3.2 3.2 0 012.19.85 2.92 2.92 0 01.89 2.15zm-1.18 0a2.32 2.32 0 00-.5-1.42 1.83 1.83 0 00-1.4-.62c-.3 0-.57.05-.81.16-.23.11-.43.26-.6.46-.15.18-.27.4-.36.64a2.52 2.52 0 000 1.56c.09.25.2.47.37.66a1.74 1.74 0 001.4.63 1.83 1.83 0 001.4-.63 2.32 2.32 0 00.5-1.44zm3.43-2.83a7.42 7.42 0 01.05.94h.03a2.01 2.01 0 01.72-.77 1.98 1.98 0 011.13-.32c.37 0 .69.06.95.19a1.86 1.86 0 011.04 1.22c.1.28.14.58.14.9V21h-1.13v-3.16c0-.23-.02-.45-.06-.66-.03-.2-.1-.39-.2-.55a.95.95 0 00-.39-.38 1.3 1.3 0 00-.65-.15c-.45 0-.81.18-1.1.52-.28.34-.42.79-.42 1.36V21H99.4v-4.46a18.35 18.35 0 00-.05-1.23h1.07zm4.41 7.54c.16.04.31.06.46.06a.7.7 0 00.4-.1.6.6 0 00.24-.26c.06-.1.1-.23.11-.39.03-.14.04-.3.04-.46v-6.4h1.13v6.42c0 .29-.03.56-.09.82-.05.25-.14.48-.27.68-.14.2-.33.36-.57.47a2.55 2.55 0 01-1.26.16 6.79 6.79 0 01-.31-.05l.12-.96zm2.57-9.59a.7.7 0 01-.23.52.74.74 0 01-.53.2.78.78 0 01-.54-.2.7.7 0 01-.21-.52c0-.2.07-.38.21-.52a.76.76 0 01.54-.21c.21 0 .39.07.53.21.15.14.23.31.23.52zm7.2 4.88a3 3 0 01-.89 2.18 2.98 2.98 0 01-2.18.84 2.98 2.98 0 01-2.18-.84c-.28-.28-.5-.6-.65-.96a3.14 3.14 0 01-.23-1.22 2.94 2.94 0 01.88-2.15 3.2 3.2 0 012.18-.84 3.2 3.2 0 012.18.85 2.92 2.92 0 01.89 2.15zm-1.17 0a2.32 2.32 0 00-.5-1.42 1.83 1.83 0 00-1.4-.62c-.3 0-.58.05-.82.16a1.99 1.99 0 00-.96 1.1 2.52 2.52 0 000 1.56c.1.25.22.47.38.66a1.74 1.74 0 001.4.63 1.83 1.83 0 001.4-.63 2.32 2.32 0 00.5-1.44zm6.41 2.86a7.43 7.43 0 01-.05-.94h-.02a2.1 2.1 0 01-1.86 1.1c-.37 0-.69-.06-.96-.18a1.86 1.86 0 01-.66-.5c-.17-.21-.3-.46-.38-.74a3.26 3.26 0 01-.12-.9v-3.53h1.13v3.15c0 .23.01.45.04.67.04.2.11.39.2.55.1.16.23.29.4.38.17.1.39.15.65.15.46 0 .83-.17 1.1-.5.28-.35.42-.8.42-1.37V15.3h1.13v4.47a18.35 18.35 0 00.05 1.22h-1.07zm2.65-4.46a18.35 18.35 0 00-.05-1.23h1.07a7.43 7.43 0 01.05.96h.03a1.94 1.94 0 012.19-1.07l-.05 1.05a2.12 2.12 0 00-.52-.06 1.52 1.52 0 00-1.5 1.14c-.06.21-.1.44-.1.68V21h-1.12v-4.46z"
      fill="#3F2D51"
    />
    <g filter="url(#languages-bubble_svg__d)" clipRule="evenodd">
      <path
        fillRule="evenodd"
        d="M52.54 61.96l-3.03-9.79V37.16c0-2.85-2.66-5.16-5.95-5.16H6.96C3.66 32 1 34.31 1 37.16v16.7c0 2.85 2.67 5.16 5.96 5.16H39.9l12.64 2.94z"
        fill="#fff"
      />
      <path
        d="M52.54 61.96l-3.03-9.79V37.16c0-2.85-2.66-5.16-5.95-5.16H6.96C3.66 32 1 34.31 1 37.16v16.7c0 2.85 2.67 5.16 5.96 5.16H39.9l12.64 2.94z"
        stroke="#3F2D51"
      />
    </g>
    <path
      d="M9.55 52.65v-6.01h1.19v6.01H9.55zm1.4-7.77c0 .21-.07.4-.22.55a.78.78 0 01-.58.23.78.78 0 01-.57-1.34.79.79 0 01.57-.24.8.8 0 01.81.8zm2.24-3.38h1.19v3.56h4.3V41.5h1.2V50h-1.2v-3.89h-4.3V50h-1.2v-8.5zm14.44 5.64a3 3 0 01-.89 2.18 2.98 2.98 0 01-2.18.84 2.98 2.98 0 01-2.18-.84c-.28-.28-.5-.6-.65-.96a3.14 3.14 0 01-.23-1.22 2.94 2.94 0 01.88-2.15 3.2 3.2 0 012.18-.84 3.2 3.2 0 012.18.85 2.92 2.92 0 01.89 2.15zm-1.18 0a2.32 2.32 0 00-.49-1.42 1.83 1.83 0 00-1.4-.62c-.3 0-.58.05-.82.16a1.99 1.99 0 00-.96 1.1 2.52 2.52 0 000 1.56c.09.25.21.47.37.66a1.74 1.74 0 001.4.63 1.83 1.83 0 001.41-.63 2.32 2.32 0 00.5-1.44zm3.9 2.86h-1.13v-9.07h1.13V50zm5.5-3.68c0-.43-.13-.74-.38-.94-.26-.2-.6-.31-1.02-.31-.32 0-.63.06-.91.19-.28.12-.52.28-.71.47l-.6-.72c.28-.27.62-.47 1.02-.63a3.72 3.72 0 012.36-.04c.3.1.55.26.75.46.19.2.33.44.43.71.1.27.14.57.14.88v2.48l.01.61c.02.21.04.38.08.52H36c-.07-.27-.1-.54-.1-.82h-.04a2.17 2.17 0 01-1.9.96c-.23 0-.46-.03-.71-.1a1.95 1.95 0 01-.66-.28c-.2-.14-.37-.32-.5-.54-.13-.22-.2-.5-.2-.83 0-.43.12-.77.35-1.02.23-.25.54-.45.91-.57.38-.14.8-.23 1.27-.27.48-.04.95-.06 1.43-.06v-.15zm-.27.97l-.88.03c-.3.03-.57.08-.82.15-.24.07-.44.18-.6.32a.74.74 0 00-.24.58c0 .17.04.3.1.42.07.11.16.2.28.27.1.08.23.13.37.16.13.02.27.04.42.04.53 0 .93-.16 1.21-.47.29-.32.43-.72.43-1.2v-.3h-.27zm4.86.23h-1.2V41.5h1.2v6.02zm.21 1.76c0 .2-.07.4-.23.55a.76.76 0 01-.57.24.78.78 0 01-.58-1.33.76.76 0 01.58-.24.78.78 0 01.8.78z"
      fill="#3F2D51"
    />
    <g filter="url(#languages-bubble_svg__e)" clipRule="evenodd">
      <path
        fillRule="evenodd"
        d="M195 86.66l2.7 10.45v16.04a5.42 5.42 0 005.32 5.51h32.66a5.42 5.42 0 005.32-5.51V95.3a5.42 5.42 0 00-5.32-5.5h-29.4L195 86.65z"
        fill="#fff"
      />
      <path
        d="M195 86.66l2.7 10.45v16.04a5.42 5.42 0 005.32 5.51h32.66a5.42 5.42 0 005.32-5.51V95.3a5.42 5.42 0 00-5.32-5.5h-29.4L195 86.65z"
        stroke="#3F2D51"
      />
    </g>
    <path
      d="M211.69 107.8c-.34.46-.78.84-1.31 1.12a4.9 4.9 0 01-3.73.1 4.38 4.38 0 01-1.42-.92 4.38 4.38 0 01-1.26-3.23c0-.67.11-1.27.34-1.81a4.14 4.14 0 012.38-2.32 4.9 4.9 0 013.53.01 3.38 3.38 0 011.32.99l-.93.72a2.1 2.1 0 00-.9-.71c-.37-.2-.78-.29-1.22-.29a3.18 3.18 0 00-2.35 1 3.72 3.72 0 00-.88 2.4 3.53 3.53 0 00.86 2.45 3.05 3.05 0 002.34.98c.48 0 .91-.1 1.3-.29.4-.2.72-.47.98-.84l.95.65zm2-3.5c.13-.28.36-.52.69-.72.33-.2.7-.3 1.1-.3.37 0 .69.07.95.2a1.86 1.86 0 011.05 1.22c.08.28.13.58.13.9v3.53h-1.13v-3.15c0-.23-.02-.45-.06-.66-.03-.2-.1-.39-.2-.55a.95.95 0 00-.39-.38c-.16-.1-.37-.15-.63-.15-.45 0-.82.18-1.1.52-.3.34-.44.79-.44 1.36v3h-1.13v-9.06h1.13v4.24h.02zm9.04 1.14c0-.42-.13-.73-.39-.93-.25-.21-.6-.31-1.02-.31-.32 0-.62.06-.91.19-.28.12-.52.27-.7.47l-.6-.72a2.8 2.8 0 011.01-.63 3.72 3.72 0 012.37-.05c.3.12.55.27.74.47.2.2.34.44.43.71.1.27.15.56.15.88v3.09c.02.21.05.38.08.52h-1.02c-.06-.27-.1-.55-.1-.82h-.03a2.17 2.17 0 01-1.91.96c-.22 0-.46-.03-.7-.1a1.95 1.95 0 01-.67-.28c-.2-.14-.37-.32-.5-.54-.13-.23-.2-.5-.2-.83 0-.43.12-.77.35-1.02.24-.26.54-.45.92-.58.37-.13.8-.22 1.27-.26.47-.04.95-.06 1.43-.06v-.16zm-.28.98c-.28 0-.57 0-.88.03-.3.03-.56.07-.81.15-.24.07-.44.18-.6.32a.74.74 0 00-.24.58c0 .16.03.3.1.42.07.1.16.2.27.27.11.07.24.13.37.16l.42.03c.53 0 .93-.15 1.21-.46.3-.32.44-.72.44-1.2v-.3h-.28zm-2.8-5.79h1.36l1.2 1.73h-.92l-1.64-1.73zm11.47 5.64a3 3 0 01-.89 2.17 2.98 2.98 0 01-2.18.84 2.98 2.98 0 01-2.18-.84c-.28-.27-.5-.59-.65-.96a3.14 3.14 0 01-.23-1.2 2.94 2.94 0 01.88-2.15 3.2 3.2 0 012.18-.84 3.2 3.2 0 012.18.83 2.92 2.92 0 01.89 2.15zm-1.18 0a2.32 2.32 0 00-.49-1.43 1.83 1.83 0 00-1.4-.62 1.74 1.74 0 00-1.4.62c-.17.19-.29.4-.38.65a2.52 2.52 0 000 1.56c.09.25.21.47.37.66a1.74 1.74 0 001.4.63 1.83 1.83 0 001.41-.63 2.32 2.32 0 00.5-1.44zm4.03.37h-1.18v-6h1.18v6zm.22 1.77a.8.8 0 01-.23.55.76.76 0 01-.57.24.78.78 0 01-.58-1.33.76.76 0 01.58-.24.78.78 0 01.8.78z"
      fill="#3F2D51"
    />
    <g filter="url(#languages-bubble_svg__f)" clipRule="evenodd">
      <path
        fillRule="evenodd"
        d="M159.51 89.64c3.88-4.22 6.11-9.18 6.11-14.48 0-15.44-18.94-27.96-42.3-27.96C99.93 47.2 81 59.72 81 75.16c0 15.44 18.94 27.96 42.31 27.96 9.64 0 18.52-2.13 25.63-5.72l13.68 3.59-3.1-11.35z"
        fill="#fff"
      />
      <path
        d="M159.51 89.64c3.88-4.22 6.11-9.18 6.11-14.48 0-15.44-18.94-27.96-42.3-27.96C99.93 47.2 81 59.72 81 75.16c0 15.44 18.94 27.96 42.31 27.96 9.64 0 18.52-2.13 25.63-5.72l13.68 3.59-3.1-11.35z"
        stroke="#3F2D51"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.2 76.16v8.59H96V65.67h2.2v8.59h4.87v-8.59h2.2v19.08h-2.2v-8.59h-4.86zm16.62-2.04v1.9h-4.84v6.8h5.94v1.93h-8.14V65.67h8.14v1.94h-5.94v6.51h4.84zm3.6 10.63V65.67h2.2v17.14h5.66v1.94h-7.86zm10.36 0V65.67h2.2v17.14h5.66v1.94h-7.86zm12.53-4.5c0 1.74.77 2.75 2.35 2.75 1.61 0 2.35-1 2.35-2.75V70.17c0-1.72-.74-2.76-2.35-2.76-1.58 0-2.35 1.04-2.35 2.76v10.08zm-2.17-9.97c0-2.92 1.5-4.8 4.52-4.8 3.06 0 4.55 1.88 4.55 4.8v9.86c0 2.89-1.5 4.8-4.55 4.8-3.02 0-4.52-1.91-4.52-4.8v-9.86zm11.6 14.47h2.12V82.1h-2.12v2.65zm-.03-10.11v-8.97h2.2v8.97l-.27 5.88H151l-.29-5.88z"
      fill="#3F2D51"
    />
    <defs>
      <filter
        id="languages-bubble_svg__a"
        x={20.91}
        y={96.21}
        width={46.89}
        height={34.66}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2} />
        <feColorMatrix values="0 0 0 0 0.247059 0 0 0 0 0.176471 0 0 0 0 0.317647 0 0 0 0.8 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_15_169" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_15_169" result="shape" />
      </filter>
      <filter
        id="languages-bubble_svg__b"
        x={177.5}
        y={14.5}
        width={55}
        height={40}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2} />
        <feColorMatrix values="0 0 0 0 0.247059 0 0 0 0 0.176471 0 0 0 0 0.317647 0 0 0 0.8 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_15_169" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_15_169" result="shape" />
      </filter>
      <filter
        id="languages-bubble_svg__c"
        x={75.49}
        y={0.93}
        width={58.59}
        height={34.66}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2} />
        <feColorMatrix values="0 0 0 0 0.247059 0 0 0 0 0.176471 0 0 0 0 0.317647 0 0 0 0.8 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_15_169" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_15_169" result="shape" />
      </filter>
      <filter
        id="languages-bubble_svg__d"
        x={0.5}
        y={31.5}
        width={52.78}
        height={33.14}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2} />
        <feColorMatrix values="0 0 0 0 0.247059 0 0 0 0 0.176471 0 0 0 0 0.317647 0 0 0 0.8 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_15_169" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_15_169" result="shape" />
      </filter>
      <filter
        id="languages-bubble_svg__e"
        x={194.3}
        y={85.95}
        width={47.2}
        height={35.21}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2} />
        <feColorMatrix values="0 0 0 0 0.247059 0 0 0 0 0.176471 0 0 0 0 0.317647 0 0 0 0.8 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_15_169" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_15_169" result="shape" />
      </filter>
      <filter
        id="languages-bubble_svg__f"
        x={80.5}
        y={46.7}
        width={85.62}
        height={58.92}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2} />
        <feColorMatrix values="0 0 0 0 0.247059 0 0 0 0 0.176471 0 0 0 0 0.317647 0 0 0 0.8 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_15_169" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_15_169" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default SvgLanguagesBubble;
